import { render } from "./PokemonCard.vue?vue&type=template&id=a7506c44&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"

import "./PokemonCard.vue?vue&type=style&index=0&id=a7506c44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Eric\\Desktop\\WEB\\apichu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7506c44"]])

export default __exports__